import { useState } from 'react';
import { Button, Input, Spinner } from '@crazyegginc/hatch';

import { Modal } from '/src/contexts/modal';

export function SaveFunnelModal({ name, onSave, onCancel, onStay }) {
  const [submitting, setSubmitting] = useState(false);
  const [newName, setNewName] = useState(name ?? '');

  return (
    <Modal dialogClassName="!p-6 !w-[365px]" onDismiss={onStay}>
      <Modal.Title>Save funnel?</Modal.Title>

      {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
      <Input value={newName} onChange={(e) => setNewName(e.target.value)} autoFocus aria-label="Funnel name" />

      <Modal.Actions>
        <Button
          onClick={() => {
            setSubmitting(true);
            setTimeout(() => onSave(newName), 100);
          }}
          disabled={submitting || !newName.trim()}
        >
          {submitting && (
            <span className="mr-2.5">
              <Spinner />
            </span>
          )}
          {submitting ? 'Saving Funnel...' : 'Save Funnel'}
        </Button>
        <Modal.Cancel onClick={onCancel} disabled={submitting}>
          Exit without saving
        </Modal.Cancel>
      </Modal.Actions>
    </Modal>
  );
}
